import React, { memo } from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import Breadcrumb from "../common/BreadCrumb";

const Hero = ({ header }) => {
  return (
    <div
      className="relative w-screen min-h-[628px] sm:min-h-[602px] md:min-h-[640px] lg:min-h-[514px] h-full 
      text-white overflow-y-hidden box-border"
    >
      {header.backgroundImage?.gatsbyImageData && (
        <div className="absolute w-full h-full top-0 left-0 border-inherit">
          <GatsbyImage
            image={header.backgroundImage.gatsbyImageData}
            alt={header.backgroundImage.title}
            objectFit="cover"
            objectPosition="center"
            className="joinclub_backgroundImage"
          />
        </div>
      )}
      <div className="absolute top-0 left-0 w-full h-full z-[1] bg-black/20 pt-[90px] px-5 pb-5 border-inherit">
        <div className="flex flex-col w-full h-full lg:px-[60px] py-20 box-border justify-center">
          <Breadcrumb subPage={header.breadcrumbName} />
          <h1 className="text-[40px] md:text-[62px] font-bold tracking-wide leading-[60px] md:leading-[93px] my-0 mx-0">
            {header.title}
          </h1>
          <p className="text-[15px] md:text-base leading-[27px] lg:leading-7 tracking-wide max-w-[500px] mt-[15px] lg:mt-5">
            {header.description.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default memo(Hero);
